// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1Z0Hl","actions":"GroupTable_actions__1Uygj","deleteModalFooter":"GroupTable_deleteModalFooter__1Jsx-"};